import type { PERMISSIONS } from '@src/types/permissions';

export const getFirstCorrectPermission = (
    memberPermissions: { [key in PERMISSIONS]?: boolean },
    requiredPermissions: PERMISSIONS[]
) => requiredPermissions.find((requiredPermission) => memberPermissions[requiredPermission]);
